import {COURSE_CARDS_BADGES_FETCHED_EVENT} from "../constants/events";

export default class CourseCards {
    constructor($cards, callback) {
        this.$cards = $cards;
        this.callback = callback;

        this.init();
    }

    init() {
        this.$cards.forEach(($card) => {
            $card.addEventListener('mouseenter', () => {
                this.removeHoverClass();
                $card.classList.add('-hover');
            });
            $card.addEventListener('mouseleave', (e) => {
                setTimeout(() => {
                    $card.classList.remove('-hover');
                }, 200);
            });
        });

        if (window.badgesMap) {
            this.addBadges(window.badgesMap);
        } else {
            window.addEventListener(COURSE_CARDS_BADGES_FETCHED_EVENT, ({ detail: badgesMap }) => {
                this.addBadges(badgesMap);
            });
        }
    }

    removeHoverClass() {
        this.$cards.forEach(($card) => {
            $card.classList.remove('-hover');
        });
    }

    addBadges(badgesMap) {
        this.$cards.forEach(($card) => {
            const badge = badgesMap.get($card.dataset.entryId);
            const $cardFooter = $card.querySelector('.course-card-footer');
            const $badge = $card.querySelector('.course-card-tag');

            if (!$cardFooter || $badge || !badge) {
                return;
            }

            $cardFooter.insertAdjacentHTML('afterbegin', this.getBadgeTemplate(badge.label, badge.color));
        });
    }

    getBadgeTemplate(label, color) {
        return `<p class="course-card-tag course-card_tag -${color}">${label}</p>`;
    }
}